(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(require('./may-london-style-engine.js'),require('./may-london-capsule.js'));
  else root.MayLondonTravel = factory(root.MayLondonStyleEngine,root.MayLondonCapsule);
})(typeof globalThis === 'object' ? globalThis : this, function (E,P) {
  const clean = value => String(value).normalize('NFKC').trim().toLowerCase();
  const key = line => line.kind === 'own' ? 'own:'+line.id : 'shop:'+line.handle;
  function settings(input) {
    const options={destination:'',days:3,activities:['','',''],budget:15000,maxAdditions:3,own:[],cart:[],ownForAll:false,...input};
    if(typeof options.destination!=='string'||!options.destination.trim()||options.destination.length>80||/[\r\n\x00-\x1f]/.test(options.destination))throw new RangeError('destination');
    if(!Number.isSafeInteger(options.days)||options.days<1||options.days>14)throw new RangeError('days');
    if(!Array.isArray(options.activities)||options.activities.length!==options.days||options.activities.some(value=>typeof value!=='string'||value.length>40))throw new RangeError('activities');
    if(typeof options.ownForAll!=='boolean')throw new RangeError('ownForAll');
    options.destination=options.destination.trim();options.activities=options.activities.map(clean);
    return options;
  }
  const forActivity=(options,occasion)=>!occasion||options.ownForAll?options.own:[];
  function current(catalogue,filters,options,handles) {
    return P.selected(catalogue,filters,{...options,target:1,own:[]},handles);
  }
  function result(catalogue,filters,options,handles,choices=[]) {
    const valid=current(catalogue,filters,options,handles), groups=new Map();
    for(const occasion of new Set(options.activities)){
      groups.set(occasion,P.selected(catalogue,{...filters,occasion},{...options,own:forActivity(options,occasion),target:Math.min(12,options.activities.filter(value=>value===occasion).length)},valid.additions.map(line=>line.handle)).looks);
    }
    const visited=new Set(), occurrence=new Map();
    const schedule=options.activities.map((occasion,index)=>{
      const looks=groups.get(occasion), used=occurrence.get(occasion)||0;occurrence.set(occasion,used+1);
      const choice=Number.isSafeInteger(choices[index])&&choices[index]>=0?choices[index]:used;
      const selected=looks.length?choice%looks.length:0, look=looks[selected];
      const signature=look?JSON.stringify(look.lines.map(key).sort()):'';
      const repeated=Boolean(look&&visited.has(signature));if(look)visited.add(signature);
      return {day:index+1,occasion,looks,selected,look,repeated};
    });
    const items=new Map(valid.additions.map(line=>[key(line),{line:{...line},uses:0}]));
    for(const day of schedule)for(const line of day.look?.lines||[]){
      const id=key(line);if(!items.has(id))items.set(id,{line:{...line},uses:0});items.get(id).uses++;
    }
    return {destination:options.destination,days:options.days,schedule,packing:[...items.values()],additions:valid.additions,subtotal:valid.subtotal,
      covered:schedule.filter(day=>day.look).length,complete:schedule.every(day=>day.look),distinct:visited.size};
  }
  function selected(catalogue,filters={},input={},handles=[],choices=[]) {
    return result(catalogue,filters,settings(input),handles,choices);
  }
  function plan(catalogue,filters={},input={}) {
    const options=settings(input), chosen=new Set();current(catalogue,filters,options,[]);
    const activities=[...new Set(options.activities)].sort((a,b)=>Number(!a)-Number(!b)||a.localeCompare(b));
    // First cover each activity; only then spend remaining budget on variety.
    for(const variety of [false,true])for(const occasion of activities){
      const baseline=result(catalogue,filters,options,[...chosen]);
      if(!variety&&baseline.schedule.some(day=>day.occasion===occasion&&day.look))continue;
      const already=current(catalogue,filters,options,[...chosen]);
      const relevant=current(catalogue,{...filters,occasion},options,[...chosen]).additions;
      const own=forActivity(options,occasion), refs=new Set();
      const reusable=relevant.map((line,index)=>{
        let id='planned:'+index;while(own.some(item=>item.id===id)||refs.has(id))id+=':';
        refs.add(id);return {id,category:catalogue.find(product=>product?.handle===line.handle).category};
      });
      const target=variety?Math.min(12,options.activities.filter(value=>value===occasion).length):1;
      const available=catalogue.filter(product=>E.validProduct(product)&&!chosen.has(product.handle));
      const pools=[available];
      if(!variety&&activities.filter(Boolean).length>1)pools.push(available.filter(product=>activities.every(activity=>E.matches(product,{...filters,occasion:activity}))));
      const proposals=pools.map(pool=>{
        const candidate=P.plan(pool,{...filters,occasion},{...options,
          target,own:[...reusable,...own],budget:options.budget-already.subtotal,maxAdditions:options.maxAdditions-already.additions.length});
        const handles=[...chosen,...candidate.additions.map(line=>line.handle)];
        const projected=result(catalogue,filters,options,handles);
        return {handles,gain:(projected.covered-baseline.covered)/Math.max(1,candidate.additions.length),subtotal:projected.subtotal};
      }).sort((a,b)=>b.gain-a.gain||a.subtotal-b.subtotal);
      for(const handle of proposals[0].handles)chosen.add(handle);
    }
    return result(catalogue,filters,options,[...chosen]);
  }
  return {plan,selected,key};
});
